module.exports = __webpack_public_path__ + "static/img/left-home-row-4.16e59fb2.png";